import { normalize } from 'polished';
import { createGlobalStyle } from 'styled-components';
import { agGridPopupChildStyles } from '../components/BlotterTable/styles/popoutStyles';
import { writeCssVars } from './cssVars';
import './fonts/helixicons/helixicons.css';

export const BaseStyle = createGlobalStyle`
${({ theme }) => theme.fontFace}

${normalize()};

* {
  box-sizing: border-box;

}


html,
body {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  color: ${({ theme }) => theme.colorTextDefault};
  font-family: ${({ theme }) => theme.fontFamily};
  background: ${({ theme }) => theme.backgroundBody};
  ${({ theme }) => (theme.backgroundBodyRepeat ? `background-repeat: ${theme.backgroundBodyRepeat};` : '')}
  ${({ theme }) =>
    theme.backgroundBodySize ? `background-size: ${theme.backgroundBodySize};` : 'background-size: cover;'}
  overscroll-behavior: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ${({ theme }) => agGridPopupChildStyles(theme)}
}


body {
  font-size: ${({ theme }) => theme.fontSizeDefault}rem;
  margin: 0;
}

*::-webkit-scrollbar {
  background-color: transparent;
  width: ${({ theme }) => theme.scrollbarSize}px;
  height: ${({ theme }) => theme.scrollbarSize}px;
}

*:hover::-webkit-scrollbar {
  background-color: transparent;
}

*::-webkit-scrollbar-track {
  background-color: ${({ theme }) => theme.backgroundScrollbar};
}

*::-webkit-scrollbar-thumb {
  transition: background-color 200ms ease;
  background-color: ${({ theme }) => theme.colorScrollbar};
  border-radius: ${({ theme }) => theme.borderRadiusScrollbar}px;
}

*:hover, .ag-root:hover .ag-body-horizontal-scroll-viewport, .ag-root:hover .ag-body-vertical-scroll-viewport {
  &::-webkit-scrollbar-thumb {
    transition: background-color 200ms ease;
    background-color: ${({ theme }) => theme.colorScrollbarHover};
  }
}

*::-webkit-scrollbar-thumb {
  border-radius: ${({ theme }) => theme.borderRadiusScrollbar}px;
}

*::-webkit-scrollbar-button {
  display:none;
}

&::-webkit-scrollbar-corner {
  background: transparent;
}

h1, h2, h3, h4 {
  color: ${({ theme }) => theme.colorTextImportant};
  font-weight: ${({ theme }) => theme.fontWeightRegular};
}

a {
  color: ${({ theme }) => theme.colorTextImportant};
}

:root {
  ${({ theme }) => writeCssVars({ theme, blacklist: ['fontUrl', 'name'] })}
}
`;

export const GlobalStyle = createGlobalStyle`
#root {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
`;
